export default "__VITE_ASSET__Dol5wkY1__"